import { render, staticRenderFns } from "./RegisterTable.vue?vue&type=template&id=03b6e8f9&"
import script from "./RegisterTable.vue?vue&type=script&lang=js&"
export * from "./RegisterTable.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports